import clsx from 'clsx';
import { Direction } from 'types/Utilities';
import Icon from 'components/ui/Icon';
import { useSnapArrows } from 'hooks/useSnapArrows';
import { useTranslation } from 'hooks/useTranslation';
import styles from './Testimonials.module.scss';
import Testimonial from './Testimonial';
import type { ReviewItem } from 'types/Review';

type Props = {
  items: ReviewItem[] | null;
  hideHeadline?: boolean;
  noDesktopPadding?: boolean;
};

const Testimonials = ({
  items,
  hideHeadline,
  noDesktopPadding,
}: Props): JSX.Element | null => {
  const { t } = useTranslation();
  const { goCarousel } = useSnapArrows('reviews-container', 'li');

  if (!items?.length) {
    return null;
  }

  return (
    <>
      {!hideHeadline && (
        <div className="max-w-screen-md mx-auto px-5 md:px-4 py-6 border-t border-silver-light mt-6 pt-5 pb-6">
          <h3>{t('whatOurPatientsAreSaying')}</h3>
        </div>
      )}

      <div
        className={clsx(
          styles.container,
          noDesktopPadding && styles.noDesktopPadding,
        )}
      >
        <ul id="reviews-container" className={styles.list}>
          {items.map((review, i) => (
            <li
              key={`${review.objectId}_${i}`}
              className="mx-2 border rounded border-silverLight p-4 py-5"
              style={{ scrollSnapAlign: 'start' }}
            >
              <Testimonial review={review} />
            </li>
          ))}
        </ul>
        <Icon
          type="Arrow"
          direction={Direction.LEFT}
          className="bg-white rounded-full h-8 w-8 p-2 left-0 -ml-0 absolute cursor-pointer hover:bg-bluishGrey hidden md:block"
          color="#155263"
          style={{
            boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.15)',
            top: '50%',
            transform: 'translate(-50%, -50%)',
          }}
          onClick={() => {
            goCarousel('previous');
          }}
        />
        <Icon
          type="Arrow"
          direction={Direction.RIGHT}
          className="bg-white rounded-full h-8 w-8 p-2 right-0 -mr-0 absolute cursor-pointer hover:bg-bluishGrey hidden md:block"
          color="#155263"
          style={{
            boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.15)',
            top: '50%',
            transform: 'translate(50%, -50%)',
          }}
          onClick={() => {
            goCarousel('next');
          }}
        />
      </div>
    </>
  );
};

export default Testimonials;
